<style lang="less">
.question-item {
	.answerTitle {
		background-color: #f3f4f8;
		width: 100%;
		height: 50px;
		font-size: 16px;
		color: #333333;
		line-height: 50px;
		font-weight: 500;
		h4 {
			width: 460px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			text-indent: 19px;
			float: left;
			margin: 0px;
		}
		.dataPic {
			float: right;
			.icon {
				margin: 0 5px 0 0;
				width: 20px;
				height: 20px;
			}
			span {
				cursor: pointer;
				margin-right: 18px;
				font-weight: 600;
				color: #4d4d4d;
			}
		}
	}
	.activeName {
		color: #2e9efe !important;
	}
	.icon5 {
		width: 16px !important;
		height: 16px !important;
	}
	.dataList-box {
		width: 100%;
		display: flex;
		padding: 20px 0px 50px 0;
		.graphical {
			div {
				height: 350px;
				width: 450px;
				cursor: Default !important;
			}
			flex: 1;
		}
		.dataOption {
			flex: 1;
			float: right;
			width: 350px;
			line-height: 50px;
			.dataPic {
				position: relative;
				cursor: pointer;
			}
			.icon5 {
				position: absolute;
				top: 3px;
				right: -20px;
			}
			.title {
				background-color: #dbeeff;
				color: #5d6574;
				font-size: 16px;
				width: 100%;
				.choose {
					display: inline-block;
					padding-left: 30px;
					box-sizing: border-box;
					width: calc(~'100% - 168px');
				}
				.gross {
					padding-left: 30px;
					box-sizing: border-box;
					width: 168px;
				}
			}
			.optionList {
				height: 49px;
				color: #464b55;
				width: 100%;
				background-color: #f4f7fa;
				border-bottom: 1px solid #fff;
				.optionData {
					width: 350px;
					padding-left: 29px;
					box-sizing: border-box;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					float: left;
				}
				.signColor {
					width: 12px;
					height: 12px;
					display: inline-block;
					border-radius: 6px;
					margin-right: 8px;
					background-color: #8543e0;
				}
				.numData {
					float: left;
					width: 168px;
					padding-left: 34px;
					box-sizing: border-box;
				}
			}
		}
	}
}
</style>
<template>
	<div class="question-item">
		<div>
			<div class="answerTitle">
				<h4>{{ item.title }}({{ item.typeText }})</h4>
			</div>
			<div class="dataList-box">
				<div class="graphical">
					<!-- 饼状图 -->
					<echart v-show="showType == '1'" :data="dataPipe" />
					<!-- 柱形图 -->
					<echart v-show="showType == '3'" :data="dataColumn" />
					<!-- 条形图 -->
					<echart v-show="showType == '2'" :data="dataBar" />
				</div>
				<div class="dataOption">
					<div class="title">
						<span class="choose">选项</span>
					</div>
					<div v-for="(items, key, index) in item.data" :key="index" class="optionList">
						<div class="optionData">
							<span :style="{ background: [colorArray[index].color] }" class="signColor" />
							&nbsp;{{ key }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import echart from '@/components/echart.vue';
const colorArray = [
	{
		color: '#e86f97',
	},
	{
		color: '#ee8d67',
	},
	{
		color: '#63c1cc',
	},
	{
		color: '#7e67ee',
	},
	{
		color: '#cc6363',
	},
	{
		color: '#80c693',
	},
	{
		color: '#669cc9',
	},
	{
		color: '#4a65ec',
	},
	{
		color: '#efd786',
	},
	{
		color: '#ebbe6c',
	},
	{
		color: '#46956A',
	},
	{
		color: '#A1973E',
	},
	{
		color: '#EE8767',
	},
	{
		color: '#26873d',
	},
	{
		color: '#6e3b58',
	},
	{
		color: '#3a4d96',
	},
	{
		color: '#27867b',
	},
	{
		color: '#8E4A45',
	},
	{
		color: '#835F80',
	},
	{
		color: '#3F8194',
	},
];
const colorList = [
	'#e86f97',
	'#ee8d67',
	'#63c1cc',
	'#7e67ee',
	'#cc6363',
	'#80c693',
	'#669cc9',
	'#4a65ec',
	'#efd786',
	'#ebbe6c',
	'#46956A',
	'#A1973E',
	'#EE8767',
	'#26873d',
	'#6e3b58',
	'#3a4d96',
	'#27867b',
	'#8E4A45',
	'#835F80',
	'#3F8194',
];
export default {
	components: {
		echart,
	},
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			colorArray,
			showType: '2',
			active: '2',
			dataSort: false,
		};
	},
	computed: {
		//柱形图
		dataBar() {
			var total = this.item.total;
			var data = {
				x: [],
				num: [],
			};
			var i = 0;
			for (const attr in this.item.data) {
				if (attr.length >= 4) {
					var newstr = attr.substr(0, 4) + '...';
					data.x.push(newstr);
				} else {
					data.x.push(attr);
				}
				if (Number.isInteger((this.item.data[attr] / total) * 100)) {
					data.num.push((this.item.data[attr] / total) * 100);
				} else {
					data.num.push(((this.item.data[attr] / total) * 100).toFixed(2));
				}
				i++;
			}

			const rotate = data.x.length > 6 ? -40 : 0;
			const barWidth = data.x.length > 10 ? 10 : 28;
			return {
				xAxis: {
					show: true,
					data: data.x,
					axisLine: {
						// 坐标轴线
						show: true, // 默认显示，属性show控制显示与否
						lineStyle: {
							// 属性lineStyle控制线条样式
							color: '#71ecc9',
							width: 1,
							type: 'solid',
						},
					},
					axisLabel: {
						textStyle: {
							fontSize: '14',
							color: '#2b313c',
						},
						interval: 0,
						rotate,
					},
					axisTick: {
						// 坐标轴小标记
						show: false,
					},
				},
				yAxis: {
					show: true,
					splitLine: {
						// 分隔线
						show: true, // 默认显示，属性show控制显示与否
						lineStyle: {
							// 属性lineStyle（详见lineStyle）控制线条样式
							color: ['#dff0eb'],
							width: 1,
							type: 'solid',
						},
					},
					axisLine: {
						// 坐标轴线
						show: true, // 默认显示，属性show控制显示与否
						lineStyle: {
							// 属性lineStyle控制线条样式
							color: '#fff',
							width: 1,
							type: 'solid',
						},
					},
				},
				grid: {
					top: '6%',
					left: '1%',
					right: '10%',
					bottom: '20%',
				},
				series: [
					{
						type: 'bar',
						label: {
							normal: {
								show: true,
								position: 'top',
							},
						},
						data: data.num,
						barWidth,
						barMaxWidth: 30,
						itemStyle: {
							normal: {
								color: function (params) {
									return colorList[params.dataIndex];
								},
								label: {
									color: '#2b313c',
									formatter: '{c}%',
								},
							},
						},
					},
				],
				animationThreshold: false,
			};
		},
		//条形图
		dataColumn() {
			var total = this.item.total;
			var data = {
				x: [],
				num: [],
			};
			var i = 0;
			for (const attr in this.item.data) {
				if (attr.length >= 6) {
					var newstr = attr.substr(0, 6) + '...';
					data.x.push(newstr);
				} else {
					data.x.push(attr);
				}
				if (Number.isInteger((this.item.data[attr] / total) * 100)) {
					data.num.push((this.item.data[attr] / total) * 100);
				} else {
					data.num.push(((this.item.data[attr] / total) * 100).toFixed(2));
				}
				i++;
			}
			const barWidth = data.x.length > 10 ? 10 : 28;
			return {
				calculable: true,
				xAxis: [
					{
						show: true,
						splitLine: {
							show: true,
							lineStyle: {
								color: ['#dff0eb'],
								width: 1,
								type: 'solid',
							},
						},
						axisLine: {
							// 坐标轴线
							show: true, // 默认显示，属性show控制显示与否
							lineStyle: {
								// 属性lineStyle控制线条样式
								color: '#fff',
								width: 1,
								type: 'solid',
							},
						},
					},
				],
				yAxis: [
					{
						type: 'category',
						data: data.x,
						inverse: true,
						axisLine: {
							// 坐标轴线
							show: true, // 默认显示，属性show控制显示与否
							lineStyle: {
								// 属性lineStyle控制线条样式
								color: '#71ecc9',
								width: 1,
								type: 'solid',
							},
						},
						axisLabel: {
							margin: 10,
							textStyle: {
								fontSize: '14',
								color: '#2b313c',
							},
						},
						axisTick: {
							// 坐标轴小标记
							show: false,
						},
					},
				],
				grid: {
					x: 10,
					y: 10,
					containLabel: true,
				},
				series: [
					{
						type: 'bar',
						data: data.num, //放百分比
						barWidth,
						barMaxWidth: 30,
						itemStyle: {
							normal: {
								color: function (params) {
									return colorList[params.dataIndex];
								},
								label: {
									show: true,
									position: 'right',
									color: '#2b313c',
									formatter: '{c}%',
								},
							},
						},
					},
				],
				animationThreshold: false,
			};
		},
		//饼状图
		dataPipe() {
			var total = this.item.total;
			var data = [];
			var i = 0;
			for (const attr in this.item.data) {
				if (attr.length >= 6) {
					var newstr = attr.substr(0, 6) + '...';
					data.push({
						name: newstr,
						value: Number.isInteger((this.item.data[attr] / total) * 100)
							? (this.item.data[attr] / total) * 100
							: ((this.item.data[attr] / total) * 100).toFixed(2),
					});
				} else {
					data.push({
						name: attr,
						value: Number.isInteger((this.item.data[attr] / total) * 100)
							? (this.item.data[attr] / total) * 100
							: ((this.item.data[attr] / total) * 100).toFixed(2),
					});
				}
				i++;
			}
			return {
				title: {
					x: 'center',
				},
				series: [
					{
						type: 'pie',
						radius: '70%',
						data: data,
						labelLine: {
							normal: {
								show: false,
								length: 5,
							},
						},
						itemStyle: {
							normal: {
								color: function (params) {
									return colorList[params.dataIndex];
								},

								label: {
									textStyle: {
										fontSize: 14,
										color: '#2b313c',
										fontWeight: 'normal',
									},
									formatter: '{b}\n{c}%',
								},
							},
						},
					},
				],
				animationThreshold: false,
			};
		},
	},
	methods: {
		//深拷贝数据
		deepClone() {
			var copyObj = {};
			copyObj = JSON.parse(JSON.stringify(this.item.data));
			return copyObj;
		},
	},
};
</script>
